import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { getSnapshot } from 'mobx-state-tree';
import { AvGroup, AvInput, AvForm } from 'availity-mobx-reactstrap-validation';
import { FormGroup } from 'reactstrap';

import { validateForm } from 'js/services/FormTools';
import AddressFormState from 'js/stores/forms/AddressFormState';
import ErrorDisplay from 'js/components/common/ErrorDisplay';
import AddressInput from 'js/components/common/AddressInput';
import AddressFeedback from 'js/components/common/AddressInput/AddressFeedback';
import Button from 'js/components/common/Button';
import SubmitRow from 'js/components/core/Modal/SubmitRow';

import Container from './Container';
import Title from './Title';
import HouseIcon from './HouseIcon';

@inject('page')
@observer
export default class Form extends Component {
  form = React.createRef();
  addressForm = AddressFormState.create({
    address: this.props.page.address ? getSnapshot(this.props.page.address) : {},
  });

  formIsValid = () =>
    this.addressForm.clearError().setWasSubmitted() &&
    validateForm(this.form.current) &&
    !this.addressForm.hasAddressError;

  onSubmit = () => {
    let formIsValid = true;
    // let formIsValid = this.formIsValid();
    return  formIsValid && this.props.page.addressSaved(this.addressForm.address);
  }

  render() {
    const addressForm = this.addressForm;
    return (
      <Container>
        <AvForm onValidSubmit={this.onSubmit} ref={this.form}>
          <HouseIcon />
          <Title>Pick-up address</Title>
          <FormGroup>
            <AddressInput
              name="address"
              id="address"
              showError={addressForm.hasAddressError}
              address={addressForm.address}
              onChange={addressForm.address.setAddress}
              placeholder="Your street address"
            />
            <AddressFeedback>Please enter and then select your address.</AddressFeedback>
          </FormGroup>

          <AvGroup>
            <AvInput
              type="text"
              name="address2"
              id="address2"
              value={addressForm.address.address2 || ''}
              onChange={addressForm.address.setAddress2}
              placeholder="Apt/suite (optional)"
            />
          </AvGroup>

          <ErrorDisplay>{addressForm.error}</ErrorDisplay>

          <SubmitRow>
            <Button autoFocus={addressForm.address.hasAddress} type="submit">
              Save
            </Button>
          </SubmitRow>
        </AvForm>
      </Container>
    );
  }
}
